import { QuickOnboardingSteps } from "features/quickOnboarding/types";
import { TranslationKeys } from "@shared/common/i18n/types.ts";
import { LanguageNameSpaces } from "@shared/types";

export const QUICK_ONBOARDING_STEP_TO_DESCRIPTION: Record<
  QuickOnboardingSteps,
  TranslationKeys<LanguageNameSpaces.COMMON>
> = {
  [QuickOnboardingSteps.WATCH_HOW_IT_WORKS]:
    "quick_onboarding.descriptions.watch_how_it_works",
  [QuickOnboardingSteps.CONNECT_EXCHANGE]:
    "quick_onboarding.descriptions.connect_exchange",
  [QuickOnboardingSteps.CREATE_BOT]: "quick_onboarding.descriptions.create_bot",
  [QuickOnboardingSteps.MONITOR_PROGRESS]:
    "quick_onboarding.descriptions.monitor_progress",
};

export const ANIMATION_WIDTH = 520;
export const ANIMATION_HEIGHT = 538;

export const SMALL_MOBILE_ANIMATION_WIDTH = 400;
export const SMALL_MOBILE_ANIMATION_HEIGHT = 415;

export const QUICK_ONBOARDING_KEY = "quick_onboarding";
export const TELEGRAM_VIEW_SIGNAL_KEY = "telegram_view_signal";

export const LINE_STEP_HEIGHT = 4;
export const LINE_STEPS_MARGIN_TOP = 24;

export const BUTTON_HEIGHT = 52;
export const BUTTON_MARGIN = 32;
export const CONTENT_MAX_HEIGHT = 142;
